/*this file is just a starting point for a central place where functions between components can be shared*/
import moment from 'moment';


/*gets an array of dates between a start date and end date*/
export const arrayOfDates = (startDate, endDate) => {
	let start = moment(startDate), end = moment(endDate);
	let dateArray = [];
	for (start; !start.isAfter(end); start.add(1, 'day')) dateArray.push(start.toString());
	return dateArray;
};

export const convertToBool = value => (value === true || value === "true") ? true : false;

export function clone(collection) {
	return JSON.parse(JSON.stringify(collection));
}

// IMPORTANT it is assumed that stateTree is freely mutable. If you're using drillAndSet
// inside of a React.Component.setState callback you should have already cloned prevState
// pathString example: "newState.values.someArray[3].field"
export function drillAndSet(stateTree, pathString, value) {
	// regex matches '[' or ']'
	let pathArray = pathString.replace(/\[|\]/g, ".") /* eslint-disable */
		.split(".")
		.filter(el => el !== "");

	let tempRef = stateTree;
	let len = pathArray.length;

	for (var i = 0; i < len-1; i++) {
		tempRef = tempRef[pathArray[i]];
	}
	tempRef[pathArray[len-1]] = value;
}

export function drillAndMerge(stateTree, pathString, value) {
	// regex matches '[' or ']'
	let pathArray = pathString.replace(/\[|\]/g, ".") /* eslint-disable */
		.split(".")
		.filter(el => el !== "");

	let tempRef = stateTree;
	let len = pathArray.length;

	for (var i = 0; i < len-1; i++) {
		tempRef = tempRef[pathArray[i]];
	}
	if (typeof value === 'object') {
		tempRef[pathArray[len-1]] = {...tempRef[pathArray[len-1]], ...value};
	} else {
		tempRef[pathArray[len-1]] = value;
	}
}

export function scrollToInvalidField() {
	let invalidElement = document.querySelectorAll('.invalid-feedback, .tropic-invalid, .is-invalid:not(.d-none)');
	if(invalidElement.length > 0) {
		invalidElement[0].scrollIntoView({behavior: "auto", block: "start", inline: "nearest"});
		
		let focusElement = invalidElement[0];
		if(invalidElement[0].tagName === 'DIV') {
			let hasElement = invalidElement[0].querySelector('input, select');
			if(hasElement) focusElement = hasElement;
		}
		focusElement.focus();
	}
}
// component: React component, updater: setState callback that returns new state
export async function asyncSetState(component, updater) {
	return new Promise((resolve) => {
		component.setState(updater, resolve);
	});
}
